module.exports = __webpack_public_path__ + "34f16462015393320ca1de60876d75f5.png";